// Class: openfl.display._internal.CanvasGraphics

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
function openfl_display__$internal_DrawCommandBuffer() {return require("./../../../openfl/display/_internal/DrawCommandBuffer");}
function openfl_geom_Matrix() {return require("./../../../openfl/geom/Matrix");}
function lime__$internal_graphics_ImageCanvasUtil() {return require("./../../../lime/_internal/graphics/ImageCanvasUtil");}
function openfl_geom_Point() {return require("./../../../openfl/geom/Point");}
function Std() {return require("./../../../Std");}
function _$UInt_UInt_$Impl_$() {return require("./../../../_UInt/UInt_Impl_");}
function openfl_display__$internal_DrawCommandReader() {return require("./../../../openfl/display/_internal/DrawCommandReader");}
function openfl_display__$internal_DrawCommandType() {return require("./../../../openfl/display/_internal/DrawCommandType");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../../openfl/_Vector/Vector_Impl_");}
function StringTools() {return require("./../../../StringTools");}
function openfl_display__$internal__$CanvasGraphics_Scale9GridBounds() {return require("./../../../openfl/display/_internal/_CanvasGraphics/Scale9GridBounds");}
function openfl_geom_Rectangle() {return require("./../../../openfl/geom/Rectangle");}
function openfl_display_BitmapData() {return require("./../../../openfl/display/BitmapData");}

// Constructor

var CanvasGraphics = function(){}

// Meta

CanvasGraphics.__name__ = "openfl.display._internal.CanvasGraphics";
CanvasGraphics.__isInterface__ = false;
CanvasGraphics.prototype = {
	
};
CanvasGraphics.prototype.__class__ = CanvasGraphics.prototype.constructor = $hxClasses["openfl.display._internal.CanvasGraphics"] = CanvasGraphics;

// Init

{
	CanvasGraphics.hitTestCanvas = typeof(window) != "undefined" ? window.document.createElement("canvas") : null;
	CanvasGraphics.hitTestContext = typeof(window) != "undefined" ? CanvasGraphics.hitTestCanvas.getContext("2d") : null;
};

// Statics

CanvasGraphics.closePath = function(strokeBefore) {
	if(strokeBefore == null) {
		strokeBefore = false;
	}
	if(CanvasGraphics.context.strokeStyle == null) {
		return;
	}
	if(!strokeBefore) {
		CanvasGraphics.context.closePath();
	}
	if(!CanvasGraphics.hitTesting && CanvasGraphics.strokePattern != null) {
		var scale9Grid = CanvasGraphics.graphics.__owner.__scale9Grid;
		var hasScale9Grid = scale9Grid != null && !CanvasGraphics.graphics.__owner.__isMask && Math.abs(CanvasGraphics.graphics.__owner.__rotation) < 0.02;
		if(CanvasGraphics.bitmapStrokeMatrix != null || hasScale9Grid && CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
			var matrix = (openfl_geom_Matrix().default).__pool.get();
			if(CanvasGraphics.bitmapStrokeMatrix != null) {
				matrix.copyFrom(CanvasGraphics.bitmapStrokeMatrix);
			} else {
				matrix.identity();
			}
			if(hasScale9Grid && CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
				var scaleX = CanvasGraphics.strokeScale9Bounds.getScaleX();
				var scaleY = CanvasGraphics.strokeScale9Bounds.getScaleY();
				if(scaleX > 0.0 && scaleY > 0.0) {
					matrix.scale(scaleX,scaleY);
				}
			}
			var strokePatternMatrix = new DOMMatrix([matrix.a,matrix.b,matrix.c,matrix.d,matrix.tx,matrix.ty]);
			CanvasGraphics.strokePattern.setTransform(strokePatternMatrix);
			(openfl_geom_Matrix().default).__pool.release(matrix);
		}
	}
	CanvasGraphics.context.stroke();
	if(strokeBefore) {
		CanvasGraphics.context.closePath();
	}
	CanvasGraphics.context.beginPath();
}
CanvasGraphics.createBitmapFill = function(bitmap,bitmapRepeat,smooth) {
	(lime__$internal_graphics_ImageCanvasUtil().default).convertToCanvas(bitmap.image);
	CanvasGraphics.setSmoothing(smooth);
	return CanvasGraphics.context.createPattern(bitmap.image.get_src(),bitmapRepeat ? "repeat" : "no-repeat");
}
CanvasGraphics.createGradientPattern = function(type,colors,alphas,ratios,matrix,spreadMethod,interpolationMethod,focalPointRatio) {
	var gradientFill = null;
	var point = null;
	var point2 = null;
	var releaseMatrix = false;
	var ratio = 0.0;
	if(matrix == null) {
		matrix = (openfl_geom_Matrix().default).__pool.get();
		matrix.identity();
		releaseMatrix = true;
	}
	switch(type) {
	case "linear":
		if(spreadMethod == "pad") {
			point = (openfl_geom_Point().default).__pool.get();
			point.setTo(-819.2,0);
			matrix.__transformPoint(point);
			point2 = (openfl_geom_Point().default).__pool.get();
			point2.setTo(819.2,0);
			matrix.__transformPoint(point2);
			var scale9Grid = CanvasGraphics.graphics.__owner.__scale9Grid;
			var hasScale9Grid = scale9Grid != null && !CanvasGraphics.graphics.__owner.__isMask && Math.abs(CanvasGraphics.graphics.__owner.__rotation) < 0.02;
			if(hasScale9Grid) {
				point.x = CanvasGraphics.toScale9Position(point.x,scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				point.y = CanvasGraphics.toScale9Position(point.y,scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				point2.x = CanvasGraphics.toScale9Position(point2.x,scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				point2.y = CanvasGraphics.toScale9Position(point2.y,scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
			}
			gradientFill = CanvasGraphics.context.createLinearGradient(point.x,point.y,point2.x,point2.y);
			CanvasGraphics.pendingMatrix = null;
			CanvasGraphics.inversePendingMatrix = null;
			var _g = 0;
			var _g1 = colors.length;
			while(_g < _g1) {
				var i = _g++;
				ratio = ratios[i] / 255;
				if(ratio < 0) {
					ratio = 0;
				} else if(ratio > 1) {
					ratio = 1;
				}
				gradientFill.addColorStop(ratio,CanvasGraphics.getRGBA(colors[i],alphas[i]));
			}
			if(point != null) {
				(openfl_geom_Point().default).__pool.release(point);
			}
			if(point2 != null) {
				(openfl_geom_Point().default).__pool.release(point2);
			}
			if(releaseMatrix) {
				(openfl_geom_Matrix().default).__pool.release(matrix);
			}
			return gradientFill;
		}
		var gradientScale = spreadMethod == "pad" ? 1.0 : 25.0;
		var dx = 0.5 * (gradientScale - 1.0) * 1638.4;
		var canvas = window.document.createElement("canvas");
		var context2 = canvas.getContext("2d");
		var dimensions = CanvasGraphics.getDimensions(matrix);
		canvas.width = CanvasGraphics.context.canvas.width;
		canvas.height = CanvasGraphics.context.canvas.height;
		gradientFill = CanvasGraphics.context.createLinearGradient(-819.2 - dx,0,819.2 + dx,0);
		if(spreadMethod == "reflect") {
			var t = 0;
			var step = 0.04;
			var a;
			while(t < 1) {
				var _g2 = 0;
				var _g11 = colors.length;
				while(_g2 < _g11) {
					var i1 = _g2++;
					ratio = ratios[i1] / 255;
					ratio = t + ratio * step;
					if(ratio < 0) {
						ratio = 0;
					} else if(ratio > 1) {
						ratio = 1;
					}
					gradientFill.addColorStop(ratio,CanvasGraphics.getRGBA(colors[i1],alphas[i1]));
				}
				t += step;
				a = colors.length - 1;
				while(a >= 0) {
					ratio = ratios[a] / 255;
					ratio = t + (1.0 - ratio) * step;
					if(ratio < 0) {
						ratio = 0;
					} else if(ratio > 1) {
						ratio = 1;
					}
					gradientFill.addColorStop(ratio,CanvasGraphics.getRGBA(colors[a],alphas[a]));
					--a;
				}
				t += step;
			}
		} else if(spreadMethod == "repeat") {
			var t1 = 0;
			var step1 = 0.04;
			var a1;
			while(t1 < 1) {
				var _g3 = 0;
				var _g12 = colors.length;
				while(_g3 < _g12) {
					var i2 = _g3++;
					ratio = ratios[i2] / 255;
					ratio = t1 + ratio * step1;
					if(ratio < 0) {
						ratio = 0;
					} else if(ratio > 1) {
						ratio = 0.999;
					}
					gradientFill.addColorStop(ratio,CanvasGraphics.getRGBA(colors[i2],alphas[i2]));
				}
				ratio = t1 + 0.001;
				if(ratio < 0) {
					ratio = 0;
				} else if(ratio > 1) {
					ratio = 1;
				}
				gradientFill.addColorStop(ratio - 0.001,CanvasGraphics.getRGBA(colors[colors.length - 1],alphas[alphas.length - 1]));
				gradientFill.addColorStop(ratio,CanvasGraphics.getRGBA(colors[0],alphas[0]));
				t1 += step1;
			}
		}
		CanvasGraphics.pendingMatrix = new (openfl_geom_Matrix().default)();
		CanvasGraphics.pendingMatrix.tx = matrix.tx - dimensions.width / 2;
		CanvasGraphics.pendingMatrix.ty = matrix.ty - dimensions.height / 2;
		CanvasGraphics.inversePendingMatrix = CanvasGraphics.pendingMatrix.clone();
		CanvasGraphics.inversePendingMatrix.invert();
		var path = new Path2D();
		path.rect(0,0,canvas.width,canvas.height);
		path.closePath();
		var gradientMatrix = new DOMMatrix([matrix.a,matrix.b,matrix.c,matrix.d,matrix.tx,matrix.ty]);
		var inverseMatrix = gradientMatrix.inverse();
		var untransformedPath = new Path2D();
		untransformedPath.addPath(path,inverseMatrix);
		context2.fillStyle = gradientFill;
		context2.setTransform(gradientMatrix.a,gradientMatrix.b,gradientMatrix.c,gradientMatrix.d,gradientMatrix.e,gradientMatrix.f);
		context2.fill(untransformedPath);
		return CanvasGraphics.context.createPattern(canvas,"no-repeat");
	case "radial":
		focalPointRatio = focalPointRatio > 1.0 ? 1.0 : focalPointRatio < -1.0 ? -1.0 : focalPointRatio;
		point = (openfl_geom_Point().default).__pool.get();
		point.x = focalPointRatio * 819.2;
		point.y = 0.0;
		matrix.__transformPoint(point);
		point2 = (openfl_geom_Point().default).__pool.get();
		point2.setTo(0.0,0.0);
		matrix.__transformPoint(point2);
		var point3 = (openfl_geom_Point().default).__pool.get();
		point3.x = 819.2;
		point3.y = 0.0;
		matrix.__transformPoint(point3);
		var scale9Grid1 = CanvasGraphics.graphics.__owner.__scale9Grid;
		var hasScale9Grid1 = scale9Grid1 != null && !CanvasGraphics.graphics.__owner.__isMask && Math.abs(CanvasGraphics.graphics.__owner.__rotation) < 0.02;
		if(hasScale9Grid1) {
			point.x = CanvasGraphics.toScale9Position(point.x,scale9Grid1.x,scale9Grid1.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
			point.y = CanvasGraphics.toScale9Position(point.y,scale9Grid1.y,scale9Grid1.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
			point2.x = CanvasGraphics.toScale9Position(point2.x,scale9Grid1.x,scale9Grid1.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
			point2.y = CanvasGraphics.toScale9Position(point2.y,scale9Grid1.y,scale9Grid1.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
			point3.x = CanvasGraphics.toScale9Position(point3.x,scale9Grid1.x,scale9Grid1.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
			point3.y = CanvasGraphics.toScale9Position(point3.y,scale9Grid1.y,scale9Grid1.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
		}
		var dx1 = point3.x - point2.x;
		var dy = point3.y - point2.y;
		(openfl_geom_Point().default).__pool.release(point3);
		var radius = Math.sqrt(dx1 * dx1 + dy * dy);
		gradientFill = CanvasGraphics.context.createRadialGradient(point.x,point.y,0.0,point2.x,point2.y,radius);
		CanvasGraphics.pendingMatrix = null;
		CanvasGraphics.inversePendingMatrix = null;
		var _g4 = 0;
		var _g13 = colors.length;
		while(_g4 < _g13) {
			var i3 = _g4++;
			ratio = ratios[i3] / 255;
			if(ratio < 0) {
				ratio = 0;
			} else if(ratio > 1) {
				ratio = 1;
			}
			gradientFill.addColorStop(ratio,CanvasGraphics.getRGBA(colors[i3],alphas[i3]));
		}
		if(point != null) {
			(openfl_geom_Point().default).__pool.release(point);
		}
		if(point2 != null) {
			(openfl_geom_Point().default).__pool.release(point2);
		}
		if(releaseMatrix) {
			(openfl_geom_Matrix().default).__pool.release(matrix);
		}
		return gradientFill;
	}
}
CanvasGraphics.getRGBA = function(color,alpha) {
	var r = (color & 16711680) >>> 16;
	var g = (color & 65280) >>> 8;
	var b = color & 255;
	return "rgba(" + (Std().default).string(r == null ? null : (_$UInt_UInt_$Impl_$().default).toFloat(r)) + ", " + (Std().default).string(g == null ? null : (_$UInt_UInt_$Impl_$().default).toFloat(g)) + ", " + (Std().default).string(b == null ? null : (_$UInt_UInt_$Impl_$().default).toFloat(b)) + ", " + alpha + ")";
}
CanvasGraphics.getDimensions = function(matrix) {
	var angle = Math.atan2(matrix.c,matrix.a);
	var cos = Math.cos(angle);
	var w = matrix.a / cos * 1638.4;
	var h = matrix.d / cos * 1638.4;
	if(w == 0 && h == 0) {
		h = 819.2;
		w = h;
	}
	return { width : w, height : h};
}
CanvasGraphics.createTempPatternCanvas = function(bitmap,repeat,width,height) {
	var canvas = window.document.createElement("canvas");
	var context = canvas.getContext("2d");
	canvas.width = width;
	canvas.height = height;
	var tmp = bitmap.image.get_src();
	context.fillStyle = context.createPattern(tmp,repeat ? "repeat" : "no-repeat");
	context.beginPath();
	context.moveTo(0,0);
	context.lineTo(0,height);
	context.lineTo(width,height);
	context.lineTo(width,0);
	context.lineTo(0,0);
	context.closePath();
	if(!CanvasGraphics.hitTesting) {
		context.fill(CanvasGraphics.windingRule);
	}
	return canvas;
}
CanvasGraphics.drawRoundRect = function(x,y,width,height,ellipseWidth,ellipseHeight,scale9Grid,scale9UnscaledWidth,scale9UnscaledHeight,scaleX,scaleY) {
	if(ellipseHeight == null) {
		ellipseHeight = ellipseWidth;
	}
	ellipseWidth *= 0.5;
	ellipseHeight *= 0.5;
	if(ellipseWidth > width / 2) {
		ellipseWidth = width / 2;
	}
	if(ellipseHeight > height / 2) {
		ellipseHeight = height / 2;
	}
	if(scale9Grid != null) {
		var scaledLeft = CanvasGraphics.toScale9Position(x,scale9Grid.x,scale9Grid.width,scale9UnscaledWidth,scaleX);
		var scaledTop = CanvasGraphics.toScale9Position(y,scale9Grid.y,scale9Grid.height,scale9UnscaledHeight,scaleY);
		var scaledRight = CanvasGraphics.toScale9Position(x + width,scale9Grid.x,scale9Grid.width,scale9UnscaledWidth,scaleX);
		var scaledBottom = CanvasGraphics.toScale9Position(y + height,scale9Grid.y,scale9Grid.height,scale9UnscaledHeight,scaleY);
		if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
			CanvasGraphics.applyScale9GridUnscaledX(x);
			CanvasGraphics.applyScale9GridUnscaledY(y);
			CanvasGraphics.applyScale9GridUnscaledX(x + width);
			CanvasGraphics.applyScale9GridUnscaledY(y + height);
			CanvasGraphics.applyScale9GridScaledX(scaledLeft);
			CanvasGraphics.applyScale9GridScaledY(scaledTop);
			CanvasGraphics.applyScale9GridScaledX(scaledRight);
			CanvasGraphics.applyScale9GridScaledY(scaledBottom);
		}
		var scaledLeftX = CanvasGraphics.toScale9Position(x + ellipseWidth,scale9Grid.x,scale9Grid.width,scale9UnscaledWidth,scaleX);
		var scaledTopY = CanvasGraphics.toScale9Position(y + ellipseHeight,scale9Grid.y,scale9Grid.height,scale9UnscaledHeight,scaleY);
		var scaledRightX = CanvasGraphics.toScale9Position(x + width - ellipseWidth,scale9Grid.x,scale9Grid.width,scale9UnscaledWidth,scaleX);
		var scaledBottomY = CanvasGraphics.toScale9Position(y + height - ellipseHeight,scale9Grid.y,scale9Grid.height,scale9UnscaledHeight,scaleY);
		CanvasGraphics.context.moveTo(scaledLeftX,scaledTop);
		CanvasGraphics.context.lineTo(scaledRightX,scaledTop);
		CanvasGraphics.context.quadraticCurveTo(scaledRight,scaledTop,scaledRight,scaledTopY);
		CanvasGraphics.context.lineTo(scaledRight,scaledBottomY);
		CanvasGraphics.context.quadraticCurveTo(scaledRight,scaledBottom,scaledRightX,scaledBottom);
		CanvasGraphics.context.lineTo(scaledLeftX,scaledBottom);
		CanvasGraphics.context.quadraticCurveTo(scaledLeft,scaledBottom,scaledLeft,scaledBottomY);
		CanvasGraphics.context.lineTo(scaledLeft,scaledTopY);
		CanvasGraphics.context.quadraticCurveTo(scaledLeft,scaledTop,scaledLeftX,scaledTop);
	} else {
		var xe = x + width;
		var ye = y + height;
		var cx1 = -ellipseWidth + ellipseWidth * 0.70710678118654752440084436210485;
		var cx2 = -ellipseWidth + ellipseWidth * 0.4142135623730950488016887242097;
		var cy1 = -ellipseHeight + ellipseHeight * 0.70710678118654752440084436210485;
		var cy2 = -ellipseHeight + ellipseHeight * 0.4142135623730950488016887242097;
		CanvasGraphics.context.moveTo(xe,ye - ellipseHeight);
		CanvasGraphics.context.quadraticCurveTo(xe,ye + cy2,xe + cx1,ye + cy1);
		CanvasGraphics.context.quadraticCurveTo(xe + cx2,ye,xe - ellipseWidth,ye);
		CanvasGraphics.context.lineTo(x + ellipseWidth,ye);
		CanvasGraphics.context.quadraticCurveTo(x - cx2,ye,x - cx1,ye + cy1);
		CanvasGraphics.context.quadraticCurveTo(x,ye + cy2,x,ye - ellipseHeight);
		CanvasGraphics.context.lineTo(x,y + ellipseHeight);
		CanvasGraphics.context.quadraticCurveTo(x,y - cy2,x - cx1,y - cy1);
		CanvasGraphics.context.quadraticCurveTo(x - cx2,y,x + ellipseWidth,y);
		CanvasGraphics.context.lineTo(xe - ellipseWidth,y);
		CanvasGraphics.context.quadraticCurveTo(xe + cx2,y,xe + cx1,y - cy1);
		CanvasGraphics.context.quadraticCurveTo(xe,y - cy2,xe,y + ellipseHeight);
		CanvasGraphics.context.lineTo(xe,ye - ellipseHeight);
	}
}
CanvasGraphics.endFill = function() {
	CanvasGraphics.context.beginPath();
	CanvasGraphics.playCommands(CanvasGraphics.fillCommands,false);
	CanvasGraphics.fillCommands.clear();
}
CanvasGraphics.endStroke = function() {
	CanvasGraphics.context.beginPath();
	CanvasGraphics.playCommands(CanvasGraphics.strokeCommands,true);
	CanvasGraphics.context.closePath();
	CanvasGraphics.strokeCommands.clear();
}
CanvasGraphics.toScale9Position = function(pos,scale9Start,scale9Center,unscaledSize,scale) {
	if(scale <= 0.0) {
		return 0.0;
	}
	var scale9End = unscaledSize - scale9Center - scale9Start;
	var size = unscaledSize * scale;
	var center = size - scale9Start - scale9End;
	if(pos <= scale9Start) {
		if(center < 0.0) {
			return pos * (scale9Start + scale9End + center) / (scale9Start + scale9End);
		}
		return pos;
	}
	if(pos >= scale9Start + scale9Center) {
		if(center < 0.0) {
			return (scale9Start + (pos - scale9Start - scale9Center)) * (scale9Start + scale9End + center) / (scale9Start + scale9End);
		}
		return scale9Start + center + (pos - scale9Start - scale9Center);
	}
	if(center < 0.0) {
		return scale9Start * (scale9Start + scale9End + center) / (scale9Start + scale9End);
	}
	return scale9Start + center * (pos - scale9Start) / scale9Center;
}
CanvasGraphics.applyScale9GridUnscaledX = function(x) {
	if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null) {
		CanvasGraphics.fillScale9Bounds.applyUnscaledX(x);
	}
	if(CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
		CanvasGraphics.strokeScale9Bounds.applyUnscaledX(x);
	}
}
CanvasGraphics.applyScale9GridUnscaledY = function(y) {
	if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null) {
		CanvasGraphics.fillScale9Bounds.applyUnscaledY(y);
	}
	if(CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
		CanvasGraphics.strokeScale9Bounds.applyUnscaledY(y);
	}
}
CanvasGraphics.applyScale9GridScaledX = function(x) {
	if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null) {
		CanvasGraphics.fillScale9Bounds.applyScaledX(x);
	}
	if(CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
		CanvasGraphics.strokeScale9Bounds.applyScaledX(x);
	}
}
CanvasGraphics.applyScale9GridScaledY = function(y) {
	if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null) {
		CanvasGraphics.fillScale9Bounds.applyScaledY(y);
	}
	if(CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
		CanvasGraphics.strokeScale9Bounds.applyScaledY(y);
	}
}
CanvasGraphics.hitTest = function(graphics,x,y) {
	CanvasGraphics.bounds = graphics.__bounds;
	CanvasGraphics.graphics = graphics;
	if(graphics.__commands.get_length() == 0 || CanvasGraphics.bounds == null || CanvasGraphics.bounds.width <= 0 || CanvasGraphics.bounds.height <= 0) {
		CanvasGraphics.graphics = null;
		return false;
	} else {
		CanvasGraphics.hitTesting = true;
		var transform = graphics.__renderTransform;
		var px = transform.__transformX(x,y);
		var py = transform.__transformY(x,y);
		x = px;
		y = py;
		x -= transform.__transformX(CanvasGraphics.bounds.x,CanvasGraphics.bounds.y);
		y -= transform.__transformY(CanvasGraphics.bounds.x,CanvasGraphics.bounds.y);
		var cacheCanvas = graphics.__canvas;
		var cacheContext = graphics.__context;
		graphics.__canvas = CanvasGraphics.hitTestCanvas;
		graphics.__context = CanvasGraphics.hitTestContext;
		CanvasGraphics.context = graphics.__context;
		CanvasGraphics.context.setTransform(transform.a,transform.b,transform.c,transform.d,transform.tx,transform.ty);
		CanvasGraphics.fillCommands.clear();
		CanvasGraphics.strokeCommands.clear();
		CanvasGraphics.hasFill = false;
		CanvasGraphics.hasStroke = false;
		CanvasGraphics.bitmapFill = null;
		CanvasGraphics.bitmapRepeat = false;
		CanvasGraphics.windingRule = "evenodd";
		var data = new (openfl_display__$internal_DrawCommandReader().default)(graphics.__commands);
		var _g = 0;
		var _g1 = graphics.__commands.types;
		while(_g < _g1.length) {
			var type = _g1[_g];
			++_g;
			switch(type._hx_index) {
			case 0:case 1:case 2:case 3:
				CanvasGraphics.endFill();
				if(CanvasGraphics.hasFill && CanvasGraphics.context.isPointInPath(x,y,CanvasGraphics.windingRule)) {
					data.destroy();
					graphics.__canvas = cacheCanvas;
					graphics.__context = cacheContext;
					CanvasGraphics.graphics = null;
					return true;
				}
				CanvasGraphics.endStroke();
				if(CanvasGraphics.hasStroke && CanvasGraphics.context.isPointInStroke(x,y)) {
					data.destroy();
					graphics.__canvas = cacheCanvas;
					graphics.__context = cacheContext;
					CanvasGraphics.graphics = null;
					return true;
				}
				if(type == (openfl_display__$internal_DrawCommandType().default).BEGIN_BITMAP_FILL) {
					var c = data.readBeginBitmapFill();
					CanvasGraphics.fillCommands.beginBitmapFill(c.obj(0),c.obj(1),c.bool(0),c.bool(1));
					CanvasGraphics.strokeCommands.beginBitmapFill(c.obj(0),c.obj(1),c.bool(0),c.bool(1));
				} else if(type == (openfl_display__$internal_DrawCommandType().default).BEGIN_GRADIENT_FILL) {
					var c1 = data.readBeginGradientFill();
					CanvasGraphics.fillCommands.beginGradientFill(c1.obj(0),c1.iArr(0),c1.fArr(0),c1.iArr(1),c1.obj(1),c1.obj(2),c1.obj(3),c1.float(0));
					CanvasGraphics.strokeCommands.beginGradientFill(c1.obj(0),c1.iArr(0),c1.fArr(0),c1.iArr(1),c1.obj(1),c1.obj(2),c1.obj(3),c1.float(0));
				} else if(type == (openfl_display__$internal_DrawCommandType().default).BEGIN_SHADER_FILL) {
					var c2 = data.readBeginShaderFill();
					CanvasGraphics.fillCommands.beginShaderFill(c2.obj(0));
					CanvasGraphics.strokeCommands.beginShaderFill(c2.obj(0));
				} else {
					var c3 = data.readBeginFill();
					CanvasGraphics.fillCommands.beginFill(c3.int(0),1);
					CanvasGraphics.strokeCommands.beginFill(c3.int(0),1);
				}
				break;
			case 4:
				var c4 = data.readCubicCurveTo();
				CanvasGraphics.fillCommands.cubicCurveTo(c4.float(0),c4.float(1),c4.float(2),c4.float(3),c4.float(4),c4.float(5));
				CanvasGraphics.strokeCommands.cubicCurveTo(c4.float(0),c4.float(1),c4.float(2),c4.float(3),c4.float(4),c4.float(5));
				break;
			case 5:
				var c5 = data.readCurveTo();
				CanvasGraphics.fillCommands.curveTo(c5.float(0),c5.float(1),c5.float(2),c5.float(3));
				CanvasGraphics.strokeCommands.curveTo(c5.float(0),c5.float(1),c5.float(2),c5.float(3));
				break;
			case 6:
				var c6 = data.readDrawCircle();
				CanvasGraphics.fillCommands.drawCircle(c6.float(0),c6.float(1),c6.float(2));
				CanvasGraphics.strokeCommands.drawCircle(c6.float(0),c6.float(1),c6.float(2));
				break;
			case 7:
				var c7 = data.readDrawEllipse();
				CanvasGraphics.fillCommands.drawEllipse(c7.float(0),c7.float(1),c7.float(2),c7.float(3));
				CanvasGraphics.strokeCommands.drawEllipse(c7.float(0),c7.float(1),c7.float(2),c7.float(3));
				break;
			case 9:
				var c8 = data.readDrawRect();
				CanvasGraphics.fillCommands.drawRect(c8.float(0),c8.float(1),c8.float(2),c8.float(3));
				CanvasGraphics.strokeCommands.drawRect(c8.float(0),c8.float(1),c8.float(2),c8.float(3));
				break;
			case 10:
				var c9 = data.readDrawRoundRect();
				CanvasGraphics.fillCommands.drawRoundRect(c9.float(0),c9.float(1),c9.float(2),c9.float(3),c9.float(4),c9.obj(0));
				CanvasGraphics.strokeCommands.drawRoundRect(c9.float(0),c9.float(1),c9.float(2),c9.float(3),c9.float(4),c9.obj(0));
				break;
			case 13:
				data.readEndFill();
				CanvasGraphics.endFill();
				if(CanvasGraphics.hasFill && CanvasGraphics.context.isPointInPath(x,y,CanvasGraphics.windingRule)) {
					data.destroy();
					graphics.__canvas = cacheCanvas;
					graphics.__context = cacheContext;
					CanvasGraphics.graphics = null;
					return true;
				}
				CanvasGraphics.endStroke();
				if(CanvasGraphics.hasStroke && CanvasGraphics.context.isPointInStroke(x,y)) {
					data.destroy();
					graphics.__canvas = cacheCanvas;
					graphics.__context = cacheContext;
					CanvasGraphics.graphics = null;
					return true;
				}
				CanvasGraphics.hasFill = false;
				CanvasGraphics.bitmapFill = null;
				break;
			case 14:
				var c10 = data.readLineBitmapStyle();
				CanvasGraphics.strokeCommands.lineBitmapStyle(c10.obj(0),c10.obj(1),c10.bool(0),c10.bool(1));
				break;
			case 15:
				var c11 = data.readLineGradientStyle();
				CanvasGraphics.strokeCommands.lineGradientStyle(c11.obj(0),c11.iArr(0),c11.fArr(0),c11.iArr(1),c11.obj(1),c11.obj(2),c11.obj(3),c11.float(0));
				break;
			case 16:
				CanvasGraphics.endStroke();
				if(CanvasGraphics.hasStroke && CanvasGraphics.context.isPointInStroke(x,y)) {
					data.destroy();
					graphics.__canvas = cacheCanvas;
					graphics.__context = cacheContext;
					CanvasGraphics.graphics = null;
					return true;
				}
				var c12 = data.readLineStyle();
				CanvasGraphics.strokeCommands.lineStyle(c12.obj(0),c12.int(0),1,c12.bool(0),c12.obj(1),c12.obj(2),c12.obj(3),c12.float(1));
				break;
			case 17:
				var c13 = data.readLineTo();
				CanvasGraphics.fillCommands.lineTo(c13.float(0),c13.float(1));
				CanvasGraphics.strokeCommands.lineTo(c13.float(0),c13.float(1));
				break;
			case 18:
				var c14 = data.readMoveTo();
				CanvasGraphics.fillCommands.moveTo(c14.float(0),c14.float(1));
				CanvasGraphics.strokeCommands.moveTo(c14.float(0),c14.float(1));
				break;
			case 21:
				CanvasGraphics.windingRule = "evenodd";
				break;
			case 22:
				CanvasGraphics.windingRule = "nonzero";
				break;
			default:
				data.skip(type);
			}
		}
		var hitTest = false;
		if(CanvasGraphics.fillCommands.get_length() > 0) {
			CanvasGraphics.endFill();
		}
		if(CanvasGraphics.hasFill && CanvasGraphics.context.isPointInPath(x,y,CanvasGraphics.windingRule)) {
			hitTest = true;
		}
		if(CanvasGraphics.strokeCommands.get_length() > 0) {
			CanvasGraphics.endStroke();
		}
		if(CanvasGraphics.hasStroke && CanvasGraphics.context.isPointInStroke(x,y)) {
			hitTest = true;
		}
		data.destroy();
		graphics.__canvas = cacheCanvas;
		graphics.__context = cacheContext;
		CanvasGraphics.graphics = null;
		return hitTest;
	}
}
CanvasGraphics.isCCW = function(x1,y1,x2,y2,x3,y3) {
	return (x2 - x1) * (y3 - y1) - (y2 - y1) * (x3 - x1) < 0;
}
CanvasGraphics.normalizeUVT = function(uvt,skipT) {
	if(skipT == null) {
		skipT = false;
	}
	var max = -Infinity;
	var tmp = -Infinity;
	var len = uvt.get_length();
	var _g = 1;
	var _g1 = len + 1;
	while(_g < _g1) {
		var t = _g++;
		if(skipT && t % 3 == 0) {
			continue;
		}
		tmp = uvt[t - 1];
		if(max < tmp) {
			max = tmp;
		}
	}
	if(!skipT) {
		return { max : max, uvt : uvt};
	}
	var result = (openfl__$Vector_Vector_$Impl_$().default)._new();
	var _g2 = 1;
	var _g3 = len + 1;
	while(_g2 < _g3) {
		var t1 = _g2++;
		if(skipT && t1 % 3 == 0) {
			continue;
		}
		(openfl__$Vector_Vector_$Impl_$().default).push(result,uvt[t1 - 1]);
	}
	return { max : max, uvt : result};
}
CanvasGraphics.playCommands = function(commands,stroke) {
	if(stroke == null) {
		stroke = false;
	}
	CanvasGraphics.bounds = CanvasGraphics.graphics.__bounds;
	var offsetX = CanvasGraphics.bounds.x;
	var offsetY = CanvasGraphics.bounds.y;
	var positionX = 0.0;
	var positionY = 0.0;
	var closeGap = false;
	var startX = 0.0;
	var startY = 0.0;
	var setStart = false;
	CanvasGraphics.windingRule = "evenodd";
	CanvasGraphics.setSmoothing(true);
	var hasPath = false;
	var scale9Grid = CanvasGraphics.graphics.__owner.__scale9Grid;
	var hasScale9Grid = scale9Grid != null && !CanvasGraphics.graphics.__owner.__isMask && Math.abs(CanvasGraphics.graphics.__owner.__rotation) < 0.02;
	if(!hasScale9Grid) {
		scale9Grid = null;
		if(CanvasGraphics.fillScale9Bounds != null) {
			CanvasGraphics.fillScale9Bounds.clear();
		}
		if(CanvasGraphics.strokeScale9Bounds != null) {
			CanvasGraphics.strokeScale9Bounds.clear();
		}
	}
	var data = new (openfl_display__$internal_DrawCommandReader().default)(commands);
	var x;
	var y;
	var width;
	var height;
	var kappa = 0.5522848;
	var ox;
	var oy;
	var xe;
	var ye;
	var xm;
	var ym;
	var r;
	var g;
	var b;
	var optimizationUsed;
	var canOptimizeMatrix;
	var st;
	var sr;
	var sb;
	var sl;
	var stl = null;
	var sbr = null;
	var _g = 0;
	var _g1 = commands.types;
	_hx_loop1: while(_g < _g1.length) {
		var type = _g1[_g];
		++_g;
		switch(type._hx_index) {
		case 0:
			var c = data.readBeginBitmapFill();
			if(c.obj(0).readable) {
				var tmp = c.obj(0);
				var tmp1 = c.bool(0);
				var tmp2 = c.bool(1);
				CanvasGraphics.context.fillStyle = CanvasGraphics.createBitmapFill(tmp,tmp1,tmp2);
				CanvasGraphics.bitmapFill = c.obj(0);
			} else {
				var tmp3 = (StringTools().default).hex(0,6);
				CanvasGraphics.context.fillStyle = "#" + tmp3;
				CanvasGraphics.bitmapFill = null;
			}
			CanvasGraphics.bitmapRepeat = c.bool(0);
			CanvasGraphics.hasFill = true;
			if(CanvasGraphics.fillScale9Bounds != null) {
				CanvasGraphics.fillScale9Bounds.clear();
			} else if(hasScale9Grid && CanvasGraphics.bitmapFill != null) {
				CanvasGraphics.fillScale9Bounds = new (openfl_display__$internal__$CanvasGraphics_Scale9GridBounds().default)();
			}
			if(c.obj(1) != null) {
				CanvasGraphics.pendingMatrix = c.obj(1);
				CanvasGraphics.inversePendingMatrix = c.obj(1).clone();
				CanvasGraphics.inversePendingMatrix.invert();
			} else {
				CanvasGraphics.pendingMatrix = null;
				CanvasGraphics.inversePendingMatrix = null;
			}
			break;
		case 1:
			var c1 = data.readBeginFill();
			if(c1.float(0) < 0.005) {
				CanvasGraphics.hasFill = false;
			} else {
				if(c1.float(0) == 1) {
					var tmp4 = (StringTools().default).hex(c1.int(0) & 16777215,6);
					CanvasGraphics.context.fillStyle = "#" + tmp4;
				} else {
					r = (c1.int(0) & 16711680) >>> 16;
					g = (c1.int(0) & 65280) >>> 8;
					b = c1.int(0) & 255;
					var tmp5 = "rgba(" + r + ", " + g + ", " + b + ", " + c1.float(0);
					CanvasGraphics.context.fillStyle = tmp5 + ")";
				}
				CanvasGraphics.hasFill = true;
				CanvasGraphics.setSmoothing(true);
			}
			CanvasGraphics.bitmapFill = null;
			if(CanvasGraphics.fillScale9Bounds != null) {
				CanvasGraphics.fillScale9Bounds.clear();
			}
			break;
		case 2:
			var c2 = data.readBeginGradientFill();
			var tmp6 = c2.obj(0);
			var tmp7 = c2.iArr(0);
			var tmp8 = c2.fArr(0);
			var tmp9 = c2.iArr(1);
			var tmp10 = c2.obj(1);
			var tmp11 = c2.obj(2);
			var tmp12 = c2.obj(3);
			CanvasGraphics.context.fillStyle = CanvasGraphics.createGradientPattern(tmp6,tmp7,tmp8,tmp9,tmp10,tmp11,tmp12,c2.float(0));
			CanvasGraphics.hasFill = true;
			CanvasGraphics.bitmapFill = null;
			CanvasGraphics.setSmoothing(true);
			if(CanvasGraphics.fillScale9Bounds != null) {
				CanvasGraphics.fillScale9Bounds.clear();
			}
			break;
		case 3:
			var c3 = data.readBeginShaderFill();
			var shaderBuffer = c3.obj(0);
			if(shaderBuffer.inputCount > 0) {
				CanvasGraphics.bitmapFill = shaderBuffer.inputs[0];
				if(CanvasGraphics.bitmapFill.readable) {
					CanvasGraphics.context.fillStyle = CanvasGraphics.createBitmapFill(CanvasGraphics.bitmapFill,shaderBuffer.inputWrap[0] != "clamp",shaderBuffer.inputFilter[0] != "nearest");
				} else {
					var tmp13 = (StringTools().default).hex(0,6);
					CanvasGraphics.context.fillStyle = "#" + tmp13;
				}
				CanvasGraphics.hasFill = true;
				CanvasGraphics.pendingMatrix = null;
				CanvasGraphics.inversePendingMatrix = null;
			}
			if(CanvasGraphics.fillScale9Bounds != null) {
				CanvasGraphics.fillScale9Bounds.clear();
			}
			break;
		case 4:
			var c4 = data.readCubicCurveTo();
			hasPath = true;
			if(hasScale9Grid) {
				var scaledControlX1 = CanvasGraphics.toScale9Position(c4.float(0),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledControlY1 = CanvasGraphics.toScale9Position(c4.float(1),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				var scaledControlX2 = CanvasGraphics.toScale9Position(c4.float(2),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledControlY2 = CanvasGraphics.toScale9Position(c4.float(3),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				var scaledAnchorX = CanvasGraphics.toScale9Position(c4.float(4),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledAnchorY = CanvasGraphics.toScale9Position(c4.float(5),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
					CanvasGraphics.applyScale9GridUnscaledX(c4.float(4));
					CanvasGraphics.applyScale9GridUnscaledY(c4.float(5));
					CanvasGraphics.applyScale9GridScaledX(scaledAnchorX);
					CanvasGraphics.applyScale9GridScaledY(scaledAnchorY);
				}
				CanvasGraphics.context.bezierCurveTo(scaledControlX1 - offsetX,scaledControlY1 - offsetY,scaledControlX2 - offsetX,scaledControlY2 - offsetY,scaledAnchorX - offsetX,scaledAnchorY - offsetY);
				positionX = scaledAnchorX;
				positionY = scaledAnchorY;
			} else {
				CanvasGraphics.context.bezierCurveTo(c4.float(0) - offsetX,c4.float(1) - offsetY,c4.float(2) - offsetX,c4.float(3) - offsetY,c4.float(4) - offsetX,c4.float(5) - offsetY);
				positionX = c4.float(4);
				positionY = c4.float(5);
			}
			break;
		case 5:
			var c5 = data.readCurveTo();
			hasPath = true;
			if(hasScale9Grid) {
				var scaledControlX = CanvasGraphics.toScale9Position(c5.float(0),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledControlY = CanvasGraphics.toScale9Position(c5.float(1),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				var scaledAnchorX1 = CanvasGraphics.toScale9Position(c5.float(2),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledAnchorY1 = CanvasGraphics.toScale9Position(c5.float(3),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
					CanvasGraphics.applyScale9GridUnscaledX(c5.float(2));
					CanvasGraphics.applyScale9GridUnscaledY(c5.float(3));
					CanvasGraphics.applyScale9GridScaledX(scaledAnchorX1);
					CanvasGraphics.applyScale9GridScaledY(scaledAnchorY1);
				}
				CanvasGraphics.context.quadraticCurveTo(scaledControlX - offsetX,scaledControlY - offsetY,scaledAnchorX1 - offsetX,scaledAnchorY1 - offsetY);
				positionX = scaledAnchorX1;
				positionY = scaledAnchorY1;
			} else {
				CanvasGraphics.context.quadraticCurveTo(c5.float(0) - offsetX,c5.float(1) - offsetY,c5.float(2) - offsetX,c5.float(3) - offsetY);
				positionX = c5.float(2);
				positionY = c5.float(3);
			}
			break;
		case 6:
			var c6 = data.readDrawCircle();
			hasPath = true;
			if(hasScale9Grid) {
				var scaledLeft = CanvasGraphics.toScale9Position(c6.float(0) - c6.float(2),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledTop = CanvasGraphics.toScale9Position(c6.float(1) - c6.float(2),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				var scaledRight = CanvasGraphics.toScale9Position(c6.float(0) + c6.float(2),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledBottom = CanvasGraphics.toScale9Position(c6.float(1) + c6.float(2),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
					CanvasGraphics.applyScale9GridUnscaledX(c6.float(0) - c6.float(2));
					CanvasGraphics.applyScale9GridUnscaledY(c6.float(1) - c6.float(2));
					CanvasGraphics.applyScale9GridUnscaledX(c6.float(0) + c6.float(2));
					CanvasGraphics.applyScale9GridUnscaledY(c6.float(1) + c6.float(2));
					CanvasGraphics.applyScale9GridScaledX(scaledLeft);
					CanvasGraphics.applyScale9GridScaledY(scaledTop);
					CanvasGraphics.applyScale9GridScaledX(scaledRight);
					CanvasGraphics.applyScale9GridScaledY(scaledBottom);
				}
				x = scaledLeft - offsetX;
				y = scaledTop - offsetY;
				width = scaledRight - scaledLeft;
				height = scaledBottom - scaledTop;
				if(width != 0.0 || height != 0.0) {
					ox = width / 2 * kappa;
					oy = height / 2 * kappa;
					xe = x + width;
					ye = y + height;
					xm = x + width / 2;
					ym = y + height / 2;
					CanvasGraphics.context.moveTo(x,ym);
					CanvasGraphics.context.bezierCurveTo(x,ym - oy,xm - ox,y,xm,y);
					CanvasGraphics.context.bezierCurveTo(xm + ox,y,xe,ym - oy,xe,ym);
					CanvasGraphics.context.bezierCurveTo(xe,ym + oy,xm + ox,ye,xm,ye);
					CanvasGraphics.context.bezierCurveTo(xm - ox,ye,x,ym + oy,x,ym);
				}
			} else if(c6.float(2) != 0.0) {
				CanvasGraphics.context.moveTo(c6.float(0) - offsetX + c6.float(2),c6.float(1) - offsetY);
				CanvasGraphics.context.arc(c6.float(0) - offsetX,c6.float(1) - offsetY,c6.float(2),0,Math.PI * 2,true);
			}
			break;
		case 7:
			var c7 = data.readDrawEllipse();
			hasPath = true;
			if(hasScale9Grid) {
				var scaledLeft1 = CanvasGraphics.toScale9Position(c7.float(0),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledTop1 = CanvasGraphics.toScale9Position(c7.float(1),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				var scaledRight1 = CanvasGraphics.toScale9Position(c7.float(0) + c7.float(2),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledBottom1 = CanvasGraphics.toScale9Position(c7.float(1) + c7.float(3),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
					CanvasGraphics.applyScale9GridUnscaledX(c7.float(0));
					CanvasGraphics.applyScale9GridUnscaledY(c7.float(1));
					CanvasGraphics.applyScale9GridUnscaledX(c7.float(0) + c7.float(2));
					CanvasGraphics.applyScale9GridUnscaledY(c7.float(1) + c7.float(3));
					CanvasGraphics.applyScale9GridScaledX(scaledLeft1);
					CanvasGraphics.applyScale9GridScaledY(scaledTop1);
					CanvasGraphics.applyScale9GridScaledX(scaledRight1);
					CanvasGraphics.applyScale9GridScaledY(scaledBottom1);
				}
				x = scaledLeft1;
				y = scaledTop1;
				width = scaledRight1 - scaledLeft1;
				height = scaledBottom1 - scaledTop1;
			} else {
				x = c7.float(0);
				y = c7.float(1);
				width = c7.float(2);
				height = c7.float(3);
			}
			if(width != 0.0 || height != 0.0) {
				x -= offsetX;
				y -= offsetY;
				ox = width / 2 * kappa;
				oy = height / 2 * kappa;
				xe = x + width;
				ye = y + height;
				xm = x + width / 2;
				ym = y + height / 2;
				CanvasGraphics.context.moveTo(x,ym);
				CanvasGraphics.context.bezierCurveTo(x,ym - oy,xm - ox,y,xm,y);
				CanvasGraphics.context.bezierCurveTo(xm + ox,y,xe,ym - oy,xe,ym);
				CanvasGraphics.context.bezierCurveTo(xe,ym + oy,xm + ox,ye,xm,ye);
				CanvasGraphics.context.bezierCurveTo(xm - ox,ye,x,ym + oy,x,ym);
			}
			break;
		case 8:
			var c8 = data.readDrawQuads();
			var rects = c8.obj(0);
			var indices = c8.obj(1);
			var transforms = c8.obj(2);
			var hasIndices = indices != null;
			var transformABCD = false;
			var transformXY = false;
			var length = hasIndices ? indices.get_length() : Math.floor(rects.get_length() / 4);
			if(length == 0) {
				return;
			}
			if(transforms != null) {
				if(transforms.get_length() >= length * 6) {
					transformABCD = true;
					transformXY = true;
				} else if(transforms.get_length() >= length * 4) {
					transformABCD = true;
				} else if(transforms.get_length() >= length * 2) {
					transformXY = true;
				}
			}
			var tileRect = (openfl_geom_Rectangle().default).__pool.get();
			var tileTransform = (openfl_geom_Matrix().default).__pool.get();
			var transform = CanvasGraphics.graphics.__renderTransform;
			var alpha = CanvasGraphics.worldAlpha;
			var ri;
			var ti;
			CanvasGraphics.context.save();
			var _g2 = 0;
			var _g11 = length;
			while(_g2 < _g11) {
				var i = _g2++;
				ri = hasIndices ? indices[i] * 4 : i * 4;
				if(ri < 0) {
					continue;
				}
				tileRect.setTo(rects[ri],rects[ri + 1],rects[ri + 2],rects[ri + 3]);
				if(tileRect.width <= 0 || tileRect.height <= 0) {
					continue;
				}
				if(transformABCD && transformXY) {
					ti = i * 6;
					tileTransform.setTo(transforms[ti],transforms[ti + 1],transforms[ti + 2],transforms[ti + 3],transforms[ti + 4],transforms[ti + 5]);
				} else if(transformABCD) {
					ti = i * 4;
					tileTransform.setTo(transforms[ti],transforms[ti + 1],transforms[ti + 2],transforms[ti + 3],tileRect.x,tileRect.y);
				} else if(transformXY) {
					ti = i * 2;
					tileTransform.tx = transforms[ti];
					tileTransform.ty = transforms[ti + 1];
				} else {
					tileTransform.tx = tileRect.x;
					tileTransform.ty = tileRect.y;
				}
				tileTransform.tx += positionX - offsetX;
				tileTransform.ty += positionY - offsetY;
				tileTransform.concat(transform);
				CanvasGraphics.context.setTransform(tileTransform.a,tileTransform.b,tileTransform.c,tileTransform.d,tileTransform.tx,tileTransform.ty);
				if(CanvasGraphics.bitmapFill != null && CanvasGraphics.bitmapFill.readable) {
					CanvasGraphics.context.drawImage(CanvasGraphics.bitmapFill.image.get_src(),tileRect.x,tileRect.y,tileRect.width,tileRect.height,0,0,tileRect.width,tileRect.height);
				} else {
					CanvasGraphics.context.fillRect(0,0,tileRect.width,tileRect.height);
				}
			}
			(openfl_geom_Rectangle().default).__pool.release(tileRect);
			(openfl_geom_Matrix().default).__pool.release(tileTransform);
			CanvasGraphics.context.restore();
			break;
		case 9:
			var c9 = data.readDrawRect();
			optimizationUsed = false;
			if(CanvasGraphics.bitmapFill != null && CanvasGraphics.bitmapFill.readable && !CanvasGraphics.hitTesting && !hasScale9Grid) {
				st = 0;
				sr = 0;
				sb = 0;
				sl = 0;
				canOptimizeMatrix = true;
				if(CanvasGraphics.pendingMatrix != null) {
					if(CanvasGraphics.pendingMatrix.b != 0 || CanvasGraphics.pendingMatrix.c != 0) {
						canOptimizeMatrix = false;
					} else {
						if(stl == null) {
							stl = (openfl_geom_Point().default).__pool.get();
						}
						if(sbr == null) {
							sbr = (openfl_geom_Point().default).__pool.get();
						}
						stl.setTo(c9.float(0),c9.float(1));
						CanvasGraphics.inversePendingMatrix.__transformPoint(stl);
						sbr.setTo(c9.float(0) + c9.float(2),c9.float(1) + c9.float(3));
						CanvasGraphics.inversePendingMatrix.__transformPoint(sbr);
						st = stl.y;
						sl = stl.x;
						sb = sbr.y;
						sr = sbr.x;
					}
				} else {
					st = c9.float(1);
					sl = c9.float(0);
					sb = c9.float(1) + c9.float(3);
					sr = c9.float(0) + c9.float(2);
				}
				if(canOptimizeMatrix && st >= 0 && sl >= 0 && sr <= CanvasGraphics.bitmapFill.width && sb <= CanvasGraphics.bitmapFill.height) {
					optimizationUsed = true;
					if(!CanvasGraphics.hitTesting) {
						CanvasGraphics.context.drawImage(CanvasGraphics.bitmapFill.image.get_src(),sl,st,sr - sl,sb - st,c9.float(0) - offsetX,c9.float(1) - offsetY,c9.float(2),c9.float(3));
					}
				}
			}
			if(!optimizationUsed) {
				hasPath = true;
				if(hasScale9Grid) {
					var scaledLeft2 = CanvasGraphics.toScale9Position(c9.float(0),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
					var scaledTop2 = CanvasGraphics.toScale9Position(c9.float(1),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
					var scaledRight2 = CanvasGraphics.toScale9Position(c9.float(0) + c9.float(2),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
					var scaledBottom2 = CanvasGraphics.toScale9Position(c9.float(1) + c9.float(3),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
					if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
						CanvasGraphics.applyScale9GridUnscaledX(c9.float(0));
						CanvasGraphics.applyScale9GridUnscaledY(c9.float(1));
						CanvasGraphics.applyScale9GridUnscaledX(c9.float(0) + c9.float(2));
						CanvasGraphics.applyScale9GridUnscaledY(c9.float(1) + c9.float(3));
						CanvasGraphics.applyScale9GridScaledX(scaledLeft2);
						CanvasGraphics.applyScale9GridScaledY(scaledTop2);
						CanvasGraphics.applyScale9GridScaledX(scaledRight2);
						CanvasGraphics.applyScale9GridScaledY(scaledBottom2);
					}
					var scaledWidth = scaledRight2 - scaledLeft2;
					var scaledHeight = scaledBottom2 - scaledTop2;
					if(scaledWidth != 0.0 || scaledHeight != 0.0) {
						CanvasGraphics.context.rect(scaledLeft2 - offsetX,scaledTop2 - offsetY,scaledWidth,scaledHeight);
					}
				} else if(c9.float(2) != 0.0 || c9.float(3) != 0.0) {
					CanvasGraphics.context.rect(c9.float(0) - offsetX,c9.float(1) - offsetY,c9.float(2),c9.float(3));
				}
			}
			break;
		case 10:
			var c10 = data.readDrawRoundRect();
			hasPath = true;
			CanvasGraphics.drawRoundRect(c10.float(0) - offsetX,c10.float(1) - offsetY,c10.float(2),c10.float(3),c10.float(4),c10.obj(0),scale9Grid,CanvasGraphics.bounds.width,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleX(),CanvasGraphics.graphics.__owner.get_scaleY());
			break;
		case 12:
			var c11 = data.readDrawTriangles();
			var v = c11.obj(0);
			var ind = c11.obj(1);
			var uvt = c11.obj(2);
			var pattern = null;
			var colorFill = CanvasGraphics.bitmapFill == null;
			if(colorFill && uvt != null) {
				break _hx_loop1;
			}
			if(!colorFill && uvt != null) {
				var skipT = uvt.get_length() != v.get_length();
				var normalizedUVT = CanvasGraphics.normalizeUVT(uvt,skipT);
				var maxUVT = normalizedUVT.max;
				uvt = normalizedUVT.uvt;
				if(maxUVT > 1) {
					pattern = CanvasGraphics.createTempPatternCanvas(CanvasGraphics.bitmapFill,CanvasGraphics.bitmapRepeat,(Std().default).int(CanvasGraphics.bounds.width),(Std().default).int(CanvasGraphics.bounds.height));
				} else {
					pattern = CanvasGraphics.createTempPatternCanvas(CanvasGraphics.bitmapFill,CanvasGraphics.bitmapRepeat,CanvasGraphics.bitmapFill.width,CanvasGraphics.bitmapFill.height);
				}
			}
			var i1 = 0;
			var l = ind.get_length();
			var a_;
			var b_;
			var c_;
			var iax;
			var iay;
			var ibx;
			var iby;
			var icx;
			var icy;
			var x1;
			var y1;
			var x2;
			var y2;
			var x3;
			var y3;
			var uvx1;
			var uvy1;
			var uvx2;
			var uvy2;
			var uvx3;
			var uvy3;
			var denom;
			var t1;
			var t2;
			var t3;
			var t4;
			var dx;
			var dy;
			while(i1 < l) {
				a_ = i1;
				b_ = i1 + 1;
				c_ = i1 + 2;
				iax = ind[a_] * 2;
				iay = ind[a_] * 2 + 1;
				ibx = ind[b_] * 2;
				iby = ind[b_] * 2 + 1;
				icx = ind[c_] * 2;
				icy = ind[c_] * 2 + 1;
				if(hasScale9Grid) {
					var scale9Grid1 = scale9Grid.x;
					var scale9Grid2 = scale9Grid.width;
					var scaledX1 = CanvasGraphics.bounds.width;
					var scaledX11 = CanvasGraphics.graphics.__owner.get_scaleX();
					var scaledX12 = CanvasGraphics.toScale9Position(v[iax],scale9Grid1,scale9Grid2,scaledX1,scaledX11);
					var scale9Grid3 = scale9Grid.y;
					var scale9Grid4 = scale9Grid.height;
					var scaledY1 = CanvasGraphics.bounds.height;
					var scaledY11 = CanvasGraphics.graphics.__owner.get_scaleY();
					var scaledY12 = CanvasGraphics.toScale9Position(v[iay],scale9Grid3,scale9Grid4,scaledY1,scaledY11);
					var scale9Grid5 = scale9Grid.x;
					var scale9Grid6 = scale9Grid.width;
					var scaledX2 = CanvasGraphics.bounds.width;
					var scaledX21 = CanvasGraphics.graphics.__owner.get_scaleX();
					var scaledX22 = CanvasGraphics.toScale9Position(v[ibx],scale9Grid5,scale9Grid6,scaledX2,scaledX21);
					var scale9Grid7 = scale9Grid.y;
					var scale9Grid8 = scale9Grid.height;
					var scaledY2 = CanvasGraphics.bounds.height;
					var scaledY21 = CanvasGraphics.graphics.__owner.get_scaleY();
					var scaledY22 = CanvasGraphics.toScale9Position(v[iby],scale9Grid7,scale9Grid8,scaledY2,scaledY21);
					var scale9Grid9 = scale9Grid.x;
					var scale9Grid10 = scale9Grid.width;
					var scaledX3 = CanvasGraphics.bounds.width;
					var scaledX31 = CanvasGraphics.graphics.__owner.get_scaleX();
					var scaledX32 = CanvasGraphics.toScale9Position(v[icx],scale9Grid9,scale9Grid10,scaledX3,scaledX31);
					var scale9Grid11 = scale9Grid.y;
					var scale9Grid12 = scale9Grid.height;
					var scaledY3 = CanvasGraphics.bounds.height;
					var scaledY31 = CanvasGraphics.graphics.__owner.get_scaleY();
					var scaledY32 = CanvasGraphics.toScale9Position(v[icy],scale9Grid11,scale9Grid12,scaledY3,scaledY31);
					if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
						CanvasGraphics.applyScale9GridUnscaledX(v[iax]);
						CanvasGraphics.applyScale9GridUnscaledY(v[iay]);
						CanvasGraphics.applyScale9GridUnscaledX(v[ibx]);
						CanvasGraphics.applyScale9GridUnscaledY(v[iby]);
						CanvasGraphics.applyScale9GridUnscaledX(v[icx]);
						CanvasGraphics.applyScale9GridUnscaledY(v[icy]);
						CanvasGraphics.applyScale9GridScaledX(scaledX12);
						CanvasGraphics.applyScale9GridScaledY(scaledY12);
						CanvasGraphics.applyScale9GridScaledX(scaledX22);
						CanvasGraphics.applyScale9GridScaledY(scaledY22);
						CanvasGraphics.applyScale9GridScaledX(scaledX32);
						CanvasGraphics.applyScale9GridScaledY(scaledY32);
					}
					x1 = scaledX12 - offsetX;
					y1 = scaledY12 - offsetY;
					x2 = scaledX22 - offsetX;
					y2 = scaledY22 - offsetY;
					x3 = scaledX32 - offsetX;
					y3 = scaledY32 - offsetY;
				} else {
					x1 = v[iax] - offsetX;
					y1 = v[iay] - offsetY;
					x2 = v[ibx] - offsetX;
					y2 = v[iby] - offsetY;
					x3 = v[icx] - offsetX;
					y3 = v[icy] - offsetY;
				}
				switch(c11.obj(3)) {
				case "negative":
					if(CanvasGraphics.isCCW(x1,y1,x2,y2,x3,y3)) {
						i1 += 3;
						continue;
					}
					break;
				case "positive":
					if(!CanvasGraphics.isCCW(x1,y1,x2,y2,x3,y3)) {
						i1 += 3;
						continue;
					}
					break;
				default:
				}
				if(colorFill || uvt == null) {
					CanvasGraphics.context.beginPath();
					CanvasGraphics.context.moveTo(x1,y1);
					CanvasGraphics.context.lineTo(x2,y2);
					CanvasGraphics.context.lineTo(x3,y3);
					CanvasGraphics.context.closePath();
					var inverseTranslateX = 0.0;
					var inverseTranslateY = 0.0;
					var inverseScaleX = 1.0;
					var inverseScaleY = 1.0;
					if(!CanvasGraphics.hitTesting && hasScale9Grid && CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null) {
						var scaleX = CanvasGraphics.fillScale9Bounds.getScaleX();
						var scaleY = CanvasGraphics.fillScale9Bounds.getScaleY();
						if(scaleX > 0.0 && scaleY > 0.0) {
							CanvasGraphics.context.scale(scaleX,scaleY);
							inverseScaleX = 1.0 / scaleX;
							inverseScaleY = 1.0 / scaleY;
							var remX = CanvasGraphics.fillScale9Bounds.unscaledMinX % CanvasGraphics.bitmapFill.width;
							var remY = CanvasGraphics.fillScale9Bounds.unscaledMinY % CanvasGraphics.bitmapFill.height;
							var adjustedRemX = CanvasGraphics.fillScale9Bounds.scale9MinX % (CanvasGraphics.bitmapFill.width * scaleX) / scaleX;
							var adjustedRemY = CanvasGraphics.fillScale9Bounds.scale9MinY % (CanvasGraphics.bitmapFill.height * scaleY) / scaleY;
							var translateX = adjustedRemX - remX;
							var translateY = adjustedRemY - remY;
							CanvasGraphics.context.translate(translateX,translateY);
							inverseTranslateX = -translateX;
							inverseTranslateY = -translateY;
						}
					}
					if(!CanvasGraphics.hitTesting) {
						CanvasGraphics.context.fill(CanvasGraphics.windingRule);
					}
					if(!CanvasGraphics.hitTesting && hasScale9Grid && CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null) {
						CanvasGraphics.context.translate(inverseTranslateX,inverseTranslateY);
						CanvasGraphics.context.scale(inverseScaleX,inverseScaleY);
					}
					i1 += 3;
					continue;
				}
				uvx1 = uvt[iax] * pattern.width;
				uvx2 = uvt[ibx] * pattern.width;
				uvx3 = uvt[icx] * pattern.width;
				uvy1 = uvt[iay] * pattern.height;
				uvy2 = uvt[iby] * pattern.height;
				uvy3 = uvt[icy] * pattern.height;
				denom = uvx1 * (uvy3 - uvy2) - uvx2 * uvy3 + uvx3 * uvy2 + (uvx2 - uvx3) * uvy1;
				if(denom == 0) {
					i1 += 3;
					CanvasGraphics.context.restore();
					continue;
				}
				CanvasGraphics.context.save();
				CanvasGraphics.context.beginPath();
				CanvasGraphics.context.moveTo(x1,y1);
				CanvasGraphics.context.lineTo(x2,y2);
				CanvasGraphics.context.lineTo(x3,y3);
				CanvasGraphics.context.closePath();
				CanvasGraphics.context.clip();
				t1 = -(uvy1 * (x3 - x2) - uvy2 * x3 + uvy3 * x2 + (uvy2 - uvy3) * x1) / denom;
				t2 = (uvy2 * y3 + uvy1 * (y2 - y3) - uvy3 * y2 + (uvy3 - uvy2) * y1) / denom;
				t3 = (uvx1 * (x3 - x2) - uvx2 * x3 + uvx3 * x2 + (uvx2 - uvx3) * x1) / denom;
				t4 = -(uvx2 * y3 + uvx1 * (y2 - y3) - uvx3 * y2 + (uvx3 - uvx2) * y1) / denom;
				dx = (uvx1 * (uvy3 * x2 - uvy2 * x3) + uvy1 * (uvx2 * x3 - uvx3 * x2) + (uvx3 * uvy2 - uvx2 * uvy3) * x1) / denom;
				dy = (uvx1 * (uvy3 * y2 - uvy2 * y3) + uvy1 * (uvx2 * y3 - uvx3 * y2) + (uvx3 * uvy2 - uvx2 * uvy3) * y1) / denom;
				CanvasGraphics.context.transform(t1,t2,t3,t4,dx,dy);
				CanvasGraphics.context.drawImage(pattern,0,0,pattern.width,pattern.height);
				CanvasGraphics.context.restore();
				i1 += 3;
			}
			break;
		case 14:
			var c12 = data.readLineBitmapStyle();
			if(stroke && CanvasGraphics.hasStroke) {
				CanvasGraphics.closePath(true);
			}
			CanvasGraphics.context.moveTo(positionX - offsetX,positionY - offsetY);
			if(c12.obj(0).readable) {
				CanvasGraphics.strokePattern = CanvasGraphics.createBitmapFill(c12.obj(0),c12.bool(0),c12.bool(1));
				CanvasGraphics.context.strokeStyle = CanvasGraphics.strokePattern;
				CanvasGraphics.bitmapStroke = c12.obj(0);
				CanvasGraphics.bitmapStrokeMatrix = c12.obj(1);
			} else {
				var tmp14 = (StringTools().default).hex(0,6);
				CanvasGraphics.context.strokeStyle = "#" + tmp14;
				CanvasGraphics.strokePattern = null;
				CanvasGraphics.bitmapStroke = null;
				CanvasGraphics.bitmapStrokeMatrix = null;
			}
			if(CanvasGraphics.strokeScale9Bounds != null) {
				CanvasGraphics.strokeScale9Bounds.clear();
			} else if(hasScale9Grid && CanvasGraphics.bitmapStroke != null) {
				CanvasGraphics.strokeScale9Bounds = new (openfl_display__$internal__$CanvasGraphics_Scale9GridBounds().default)();
			}
			CanvasGraphics.hasStroke = true;
			break;
		case 15:
			var c13 = data.readLineGradientStyle();
			if(stroke && CanvasGraphics.hasStroke) {
				CanvasGraphics.closePath(true);
			}
			CanvasGraphics.context.moveTo(positionX - offsetX,positionY - offsetY);
			CanvasGraphics.strokePattern = CanvasGraphics.createGradientPattern(c13.obj(0),c13.iArr(0),c13.fArr(0),c13.iArr(1),c13.obj(1),c13.obj(2),c13.obj(3),c13.float(0));
			CanvasGraphics.context.strokeStyle = CanvasGraphics.strokePattern;
			CanvasGraphics.setSmoothing(true);
			CanvasGraphics.hasStroke = true;
			CanvasGraphics.bitmapStroke = null;
			CanvasGraphics.bitmapStrokeMatrix = null;
			break;
		case 16:
			var c14 = data.readLineStyle();
			if(stroke && CanvasGraphics.hasStroke) {
				CanvasGraphics.closePath(true);
			}
			CanvasGraphics.context.moveTo(positionX - offsetX,positionY - offsetY);
			if(c14.obj(0) == null) {
				CanvasGraphics.hasStroke = false;
			} else {
				CanvasGraphics.hasStroke = true;
				var tmp15 = c14.obj(0) > 0 ? c14.obj(0) : 1;
				CanvasGraphics.context.lineWidth = tmp15;
				var tmp16 = c14.obj(3) == null ? "round" : (Std().default).string(c14.obj(3)).toLowerCase();
				CanvasGraphics.context.lineJoin = tmp16;
				var tmp17 = c14.obj(2) == null ? "round" : c14.obj(2) == "none" ? "butt" : (Std().default).string(c14.obj(2)).toLowerCase();
				CanvasGraphics.context.lineCap = tmp17;
				CanvasGraphics.context.miterLimit = c14.float(1);
				if(c14.float(0) == 1) {
					var tmp18 = (StringTools().default).hex(c14.int(0) & 16777215,6);
					CanvasGraphics.context.strokeStyle = "#" + tmp18;
				} else {
					r = (c14.int(0) & 16711680) >>> 16;
					g = (c14.int(0) & 65280) >>> 8;
					b = c14.int(0) & 255;
					var tmp19 = "rgba(" + r + ", " + g + ", " + b + ", " + c14.float(0);
					CanvasGraphics.context.strokeStyle = tmp19 + ")";
				}
				CanvasGraphics.setSmoothing(true);
			}
			CanvasGraphics.strokePattern = null;
			CanvasGraphics.bitmapStroke = null;
			CanvasGraphics.bitmapStrokeMatrix = null;
			break;
		case 17:
			var c15 = data.readLineTo();
			hasPath = true;
			if(hasScale9Grid) {
				var scaledX = CanvasGraphics.toScale9Position(c15.float(0),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledY = CanvasGraphics.toScale9Position(c15.float(1),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
					CanvasGraphics.applyScale9GridUnscaledX(c15.float(0));
					CanvasGraphics.applyScale9GridUnscaledY(c15.float(1));
					CanvasGraphics.applyScale9GridScaledX(scaledX);
					CanvasGraphics.applyScale9GridScaledY(scaledY);
				}
				if(positionX != scaledX || positionY != scaledY) {
					CanvasGraphics.context.lineTo(scaledX - offsetX,scaledY - offsetY);
				}
				positionX = scaledX;
				positionY = scaledY;
			} else {
				if(positionX != c15.float(0) || positionY != c15.float(1)) {
					CanvasGraphics.context.lineTo(c15.float(0) - offsetX,c15.float(1) - offsetY);
				}
				positionX = c15.float(0);
				positionY = c15.float(1);
			}
			if(positionX == startX && positionY == startY) {
				closeGap = true;
			}
			break;
		case 18:
			var c16 = data.readMoveTo();
			if(hasScale9Grid) {
				var scaledX4 = CanvasGraphics.toScale9Position(c16.float(0),scale9Grid.x,scale9Grid.width,CanvasGraphics.bounds.width,CanvasGraphics.graphics.__owner.get_scaleX());
				var scaledY4 = CanvasGraphics.toScale9Position(c16.float(1),scale9Grid.y,scale9Grid.height,CanvasGraphics.bounds.height,CanvasGraphics.graphics.__owner.get_scaleY());
				if(CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null || CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
					CanvasGraphics.applyScale9GridUnscaledX(c16.float(0));
					CanvasGraphics.applyScale9GridUnscaledY(c16.float(1));
					CanvasGraphics.applyScale9GridScaledX(scaledX4);
					CanvasGraphics.applyScale9GridScaledY(scaledY4);
				}
				CanvasGraphics.context.moveTo(scaledX4 - offsetX,scaledY4 - offsetY);
				positionX = scaledX4;
				positionY = scaledY4;
			} else {
				CanvasGraphics.context.moveTo(c16.float(0) - offsetX,c16.float(1) - offsetY);
				positionX = c16.float(0);
				positionY = c16.float(1);
			}
			if(setStart && positionX != startX && positionY != startY) {
				closeGap = true;
			}
			startX = positionX;
			startY = positionY;
			setStart = true;
			break;
		case 21:
			CanvasGraphics.windingRule = "evenodd";
			break;
		case 22:
			CanvasGraphics.windingRule = "nonzero";
			break;
		default:
			data.skip(type);
		}
	}
	if(stl != null) {
		(openfl_geom_Point().default).__pool.release(stl);
	}
	if(sbr != null) {
		(openfl_geom_Point().default).__pool.release(sbr);
	}
	data.destroy();
	if(hasPath) {
		if(stroke && CanvasGraphics.hasStroke) {
			if(CanvasGraphics.hasFill) {
				if(positionX != startX || positionY != startY) {
					CanvasGraphics.context.lineTo(startX - offsetX,startY - offsetY);
					closeGap = true;
				}
				if(closeGap) {
					CanvasGraphics.closePath(true);
				}
			} else if(closeGap && positionX == startX && positionY == startY) {
				CanvasGraphics.closePath(true);
			}
			if(!CanvasGraphics.hitTesting && CanvasGraphics.strokePattern != null && (CanvasGraphics.bitmapStrokeMatrix != null || hasScale9Grid && CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null)) {
				var matrix = (openfl_geom_Matrix().default).__pool.get();
				if(CanvasGraphics.bitmapStrokeMatrix != null) {
					matrix.copyFrom(CanvasGraphics.bitmapStrokeMatrix);
				} else {
					matrix.identity();
				}
				if(hasScale9Grid && CanvasGraphics.strokeScale9Bounds != null && CanvasGraphics.bitmapStroke != null) {
					var scaleX1 = CanvasGraphics.strokeScale9Bounds.getScaleX();
					var scaleY1 = CanvasGraphics.strokeScale9Bounds.getScaleY();
					if(scaleX1 > 0.0 && scaleY1 > 0.0) {
						matrix.scale(scaleX1,scaleY1);
					}
				}
				var strokePatternMatrix = new DOMMatrix([matrix.a,matrix.b,matrix.c,matrix.d,matrix.tx,matrix.ty]);
				CanvasGraphics.strokePattern.setTransform(strokePatternMatrix);
				(openfl_geom_Matrix().default).__pool.release(matrix);
			}
			if(!CanvasGraphics.hitTesting) {
				CanvasGraphics.context.stroke();
			}
		}
		if(!stroke) {
			if(CanvasGraphics.hasFill || CanvasGraphics.bitmapFill != null) {
				CanvasGraphics.context.translate(-CanvasGraphics.bounds.x,-CanvasGraphics.bounds.y);
				var inverseTranslateX1 = 0.0;
				var inverseTranslateY1 = 0.0;
				var inverseScaleX1 = 1.0;
				var inverseScaleY1 = 1.0;
				if(!CanvasGraphics.hitTesting && hasScale9Grid && CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null) {
					var scaleX2 = CanvasGraphics.fillScale9Bounds.getScaleX();
					var scaleY2 = CanvasGraphics.fillScale9Bounds.getScaleY();
					if(scaleX2 > 0.0 && scaleY2 > 0.0) {
						CanvasGraphics.context.scale(scaleX2,scaleY2);
						inverseScaleX1 = 1.0 / scaleX2;
						inverseScaleY1 = 1.0 / scaleY2;
						var remX1 = CanvasGraphics.fillScale9Bounds.unscaledMinX % CanvasGraphics.bitmapFill.width;
						var remY1 = CanvasGraphics.fillScale9Bounds.unscaledMinY % CanvasGraphics.bitmapFill.height;
						var adjustedRemX1 = CanvasGraphics.fillScale9Bounds.scale9MinX % (CanvasGraphics.bitmapFill.width * scaleX2) / scaleX2;
						var adjustedRemY1 = CanvasGraphics.fillScale9Bounds.scale9MinY % (CanvasGraphics.bitmapFill.height * scaleY2) / scaleY2;
						var translateX1 = adjustedRemX1 - remX1;
						var translateY1 = adjustedRemY1 - remY1;
						CanvasGraphics.context.translate(translateX1,translateY1);
						inverseTranslateX1 = -translateX1;
						inverseTranslateY1 = -translateY1;
					}
				}
				if(CanvasGraphics.pendingMatrix != null) {
					CanvasGraphics.context.transform(CanvasGraphics.pendingMatrix.a,CanvasGraphics.pendingMatrix.b,CanvasGraphics.pendingMatrix.c,CanvasGraphics.pendingMatrix.d,CanvasGraphics.pendingMatrix.tx,CanvasGraphics.pendingMatrix.ty);
					if(!CanvasGraphics.hitTesting) {
						CanvasGraphics.context.fill(CanvasGraphics.windingRule);
					}
					CanvasGraphics.context.transform(CanvasGraphics.inversePendingMatrix.a,CanvasGraphics.inversePendingMatrix.b,CanvasGraphics.inversePendingMatrix.c,CanvasGraphics.inversePendingMatrix.d,CanvasGraphics.inversePendingMatrix.tx,CanvasGraphics.inversePendingMatrix.ty);
				} else if(!CanvasGraphics.hitTesting) {
					CanvasGraphics.context.fill(CanvasGraphics.windingRule);
				}
				if(!CanvasGraphics.hitTesting && hasScale9Grid && CanvasGraphics.fillScale9Bounds != null && CanvasGraphics.bitmapFill != null) {
					CanvasGraphics.context.translate(inverseTranslateX1,inverseTranslateY1);
					CanvasGraphics.context.scale(inverseScaleX1,inverseScaleY1);
				}
				CanvasGraphics.context.translate(CanvasGraphics.bounds.x,CanvasGraphics.bounds.y);
				CanvasGraphics.context.closePath();
			}
		}
	}
}
CanvasGraphics.render = function(graphics,renderer) {
	var pixelRatio = renderer.__pixelRatio;
	var scale9Grid = graphics.__owner.__scale9Grid;
	var hasScale9Grid = scale9Grid != null && !graphics.__owner.__isMask && Math.abs(graphics.__owner.__rotation) < 0.02;
	if(hasScale9Grid) {
		graphics.__bitmapScaleX = graphics.__owner.get_scaleX();
		graphics.__bitmapScaleY = graphics.__owner.get_scaleY();
	} else {
		graphics.__bitmapScaleX = 1;
		graphics.__bitmapScaleY = 1;
	}
	graphics.__update(renderer.__worldTransform,pixelRatio);
	if(graphics.__softwareDirty) {
		CanvasGraphics.hitTesting = false;
		CanvasGraphics.graphics = graphics;
		CanvasGraphics.allowSmoothing = renderer.__allowSmoothing;
		CanvasGraphics.worldAlpha = renderer.__getAlpha(graphics.__owner.__worldAlpha);
		CanvasGraphics.bounds = graphics.__bounds;
		var width = graphics.__width;
		var height = graphics.__height;
		if(!graphics.__visible || graphics.__commands.get_length() == 0 || CanvasGraphics.bounds == null || width < 1 || height < 1) {
			graphics.__canvas = null;
			graphics.__context = null;
			graphics.__bitmap = null;
		} else {
			if(graphics.__canvas == null) {
				graphics.__canvas = window.document.createElement("canvas");
				graphics.__context = graphics.__canvas.getContext("2d");
			}
			CanvasGraphics.context = graphics.__context;
			var transform = graphics.__renderTransform;
			var canvas = graphics.__canvas;
			var scale = renderer.__pixelRatio;
			var scaledWidth = (Std().default).int(width * scale);
			var scaledHeight = (Std().default).int(height * scale);
			renderer.__setBlendModeContext(CanvasGraphics.context,"normal");
			if(renderer.__isDOM) {
				if(canvas.width == scaledWidth && canvas.height == scaledHeight) {
					CanvasGraphics.context.clearRect(0,0,scaledWidth,scaledHeight);
				} else {
					canvas.width = scaledWidth;
					canvas.height = scaledHeight;
					canvas.style.width = width + "px";
					canvas.style.height = height + "px";
				}
				var transform1 = graphics.__renderTransform;
				CanvasGraphics.context.setTransform(transform1.a * scale,transform1.b * scale,transform1.c * scale,transform1.d * scale,transform1.tx * scale,transform1.ty * scale);
			} else {
				if(canvas.width == scaledWidth && canvas.height == scaledHeight) {
					CanvasGraphics.context.closePath();
					CanvasGraphics.context.setTransform(1,0,0,1,0,0);
					CanvasGraphics.context.clearRect(0,0,scaledWidth,scaledHeight);
				} else {
					canvas.width = width;
					canvas.height = height;
				}
				CanvasGraphics.context.setTransform(transform.a,transform.b,transform.c,transform.d,transform.tx,transform.ty);
			}
			CanvasGraphics.fillCommands.clear();
			CanvasGraphics.strokeCommands.clear();
			CanvasGraphics.hasFill = false;
			CanvasGraphics.hasStroke = false;
			CanvasGraphics.bitmapFill = null;
			CanvasGraphics.bitmapRepeat = false;
			var hasLineStyle = false;
			var initStrokeX = 0.0;
			var initStrokeY = 0.0;
			CanvasGraphics.windingRule = "evenodd";
			var data = new (openfl_display__$internal_DrawCommandReader().default)(graphics.__commands);
			var _g = 0;
			var _g1 = graphics.__commands.types;
			while(_g < _g1.length) {
				var type = _g1[_g];
				++_g;
				switch(type._hx_index) {
				case 0:case 1:case 2:case 3:
					CanvasGraphics.endFill();
					CanvasGraphics.endStroke();
					if(type == (openfl_display__$internal_DrawCommandType().default).BEGIN_BITMAP_FILL) {
						var c = data.readBeginBitmapFill();
						CanvasGraphics.fillCommands.beginBitmapFill(c.obj(0),c.obj(1),c.bool(0),c.bool(1));
						CanvasGraphics.strokeCommands.beginBitmapFill(c.obj(0),c.obj(1),c.bool(0),c.bool(1));
					} else if(type == (openfl_display__$internal_DrawCommandType().default).BEGIN_GRADIENT_FILL) {
						var c1 = data.readBeginGradientFill();
						CanvasGraphics.fillCommands.beginGradientFill(c1.obj(0),c1.iArr(0),c1.fArr(0),c1.iArr(1),c1.obj(1),c1.obj(2),c1.obj(3),c1.float(0));
						CanvasGraphics.strokeCommands.beginGradientFill(c1.obj(0),c1.iArr(0),c1.fArr(0),c1.iArr(1),c1.obj(1),c1.obj(2),c1.obj(3),c1.float(0));
					} else if(type == (openfl_display__$internal_DrawCommandType().default).BEGIN_SHADER_FILL) {
						var c2 = data.readBeginShaderFill();
						CanvasGraphics.fillCommands.beginShaderFill(c2.obj(0));
						CanvasGraphics.strokeCommands.beginShaderFill(c2.obj(0));
					} else {
						var c3 = data.readBeginFill();
						CanvasGraphics.fillCommands.beginFill(c3.int(0),c3.float(0));
						CanvasGraphics.strokeCommands.beginFill(c3.int(0),c3.float(0));
					}
					break;
				case 4:
					var c4 = data.readCubicCurveTo();
					CanvasGraphics.fillCommands.cubicCurveTo(c4.float(0),c4.float(1),c4.float(2),c4.float(3),c4.float(4),c4.float(5));
					if(hasLineStyle) {
						CanvasGraphics.strokeCommands.cubicCurveTo(c4.float(0),c4.float(1),c4.float(2),c4.float(3),c4.float(4),c4.float(5));
					} else {
						initStrokeX = c4.float(4);
						initStrokeY = c4.float(5);
					}
					break;
				case 5:
					var c5 = data.readCurveTo();
					CanvasGraphics.fillCommands.curveTo(c5.float(0),c5.float(1),c5.float(2),c5.float(3));
					if(hasLineStyle) {
						CanvasGraphics.strokeCommands.curveTo(c5.float(0),c5.float(1),c5.float(2),c5.float(3));
					} else {
						initStrokeX = c5.float(2);
						initStrokeY = c5.float(3);
					}
					break;
				case 6:
					var c6 = data.readDrawCircle();
					CanvasGraphics.fillCommands.drawCircle(c6.float(0),c6.float(1),c6.float(2));
					if(hasLineStyle) {
						CanvasGraphics.strokeCommands.drawCircle(c6.float(0),c6.float(1),c6.float(2));
					}
					break;
				case 7:
					var c7 = data.readDrawEllipse();
					CanvasGraphics.fillCommands.drawEllipse(c7.float(0),c7.float(1),c7.float(2),c7.float(3));
					if(hasLineStyle) {
						CanvasGraphics.strokeCommands.drawEllipse(c7.float(0),c7.float(1),c7.float(2),c7.float(3));
					}
					break;
				case 8:
					var c8 = data.readDrawQuads();
					CanvasGraphics.fillCommands.drawQuads(c8.obj(0),c8.obj(1),c8.obj(2));
					break;
				case 9:
					var c9 = data.readDrawRect();
					CanvasGraphics.fillCommands.drawRect(c9.float(0),c9.float(1),c9.float(2),c9.float(3));
					if(hasLineStyle) {
						CanvasGraphics.strokeCommands.drawRect(c9.float(0),c9.float(1),c9.float(2),c9.float(3));
					}
					break;
				case 10:
					var c10 = data.readDrawRoundRect();
					CanvasGraphics.fillCommands.drawRoundRect(c10.float(0),c10.float(1),c10.float(2),c10.float(3),c10.float(4),c10.obj(0));
					if(hasLineStyle) {
						CanvasGraphics.strokeCommands.drawRoundRect(c10.float(0),c10.float(1),c10.float(2),c10.float(3),c10.float(4),c10.obj(0));
					}
					break;
				case 12:
					var c11 = data.readDrawTriangles();
					CanvasGraphics.fillCommands.drawTriangles(c11.obj(0),c11.obj(1),c11.obj(2),c11.obj(3));
					break;
				case 13:
					data.readEndFill();
					CanvasGraphics.endFill();
					CanvasGraphics.endStroke();
					CanvasGraphics.hasFill = false;
					CanvasGraphics.bitmapFill = null;
					initStrokeX = 0;
					initStrokeY = 0;
					break;
				case 14:
					var c12 = data.readLineBitmapStyle();
					if(!hasLineStyle && (initStrokeX != 0 || initStrokeY != 0)) {
						CanvasGraphics.strokeCommands.moveTo(initStrokeX,initStrokeY);
						initStrokeX = 0;
						initStrokeY = 0;
					}
					hasLineStyle = true;
					CanvasGraphics.strokeCommands.lineBitmapStyle(c12.obj(0),c12.obj(1),c12.bool(0),c12.bool(1));
					break;
				case 15:
					var c13 = data.readLineGradientStyle();
					if(!hasLineStyle && (initStrokeX != 0 || initStrokeY != 0)) {
						CanvasGraphics.strokeCommands.moveTo(initStrokeX,initStrokeY);
						initStrokeX = 0;
						initStrokeY = 0;
					}
					hasLineStyle = true;
					CanvasGraphics.strokeCommands.lineGradientStyle(c13.obj(0),c13.iArr(0),c13.fArr(0),c13.iArr(1),c13.obj(1),c13.obj(2),c13.obj(3),c13.float(0));
					break;
				case 16:
					var c14 = data.readLineStyle();
					if(!hasLineStyle && c14.obj(0) != null) {
						if(initStrokeX != 0 || initStrokeY != 0) {
							CanvasGraphics.strokeCommands.moveTo(initStrokeX,initStrokeY);
							initStrokeX = 0;
							initStrokeY = 0;
						}
					}
					hasLineStyle = c14.obj(0) != null;
					CanvasGraphics.strokeCommands.lineStyle(c14.obj(0),c14.int(0),c14.float(0),c14.bool(0),c14.obj(1),c14.obj(2),c14.obj(3),c14.float(1));
					break;
				case 17:
					var c15 = data.readLineTo();
					CanvasGraphics.fillCommands.lineTo(c15.float(0),c15.float(1));
					if(hasLineStyle) {
						CanvasGraphics.strokeCommands.lineTo(c15.float(0),c15.float(1));
					} else {
						initStrokeX = c15.float(0);
						initStrokeY = c15.float(1);
					}
					break;
				case 18:
					var c16 = data.readMoveTo();
					CanvasGraphics.fillCommands.moveTo(c16.float(0),c16.float(1));
					if(hasLineStyle) {
						CanvasGraphics.strokeCommands.moveTo(c16.float(0),c16.float(1));
					} else {
						initStrokeX = c16.float(0);
						initStrokeY = c16.float(1);
					}
					break;
				case 19:
					var c17 = data.readOverrideBlendMode();
					renderer.__setBlendModeContext(CanvasGraphics.context,c17.obj(0));
					break;
				case 21:
					data.readWindingEvenOdd();
					CanvasGraphics.fillCommands.windingEvenOdd();
					CanvasGraphics.windingRule = "evenodd";
					break;
				case 22:
					data.readWindingNonZero();
					CanvasGraphics.fillCommands.windingNonZero();
					CanvasGraphics.windingRule = "nonzero";
					break;
				default:
					data.skip(type);
				}
			}
			if(CanvasGraphics.fillCommands.get_length() > 0) {
				CanvasGraphics.endFill();
			}
			if(CanvasGraphics.strokeCommands.get_length() > 0) {
				CanvasGraphics.endStroke();
			}
			data.destroy();
			if(graphics.__bitmap == null) {
				graphics.__bitmap = (openfl_display_BitmapData().default).fromCanvas(graphics.__canvas);
			} else if(graphics.__bitmap.width != graphics.__canvas.width || graphics.__bitmap.height != graphics.__canvas.height) {
				var texture = graphics.__bitmap.__texture;
				if(texture != null) {
					texture.dispose();
				}
				graphics.__bitmap = (openfl_display_BitmapData().default).fromCanvas(graphics.__canvas);
			} else {
				graphics.__bitmap.image.version++;
			}
		}
		graphics.__softwareDirty = false;
		graphics.set___dirty(false);
		CanvasGraphics.graphics = null;
	}
}
CanvasGraphics.renderMask = function(graphics,renderer) {
	if(graphics.__commands.get_length() != 0) {
		CanvasGraphics.context = renderer.context;
		var positionX = 0.0;
		var positionY = 0.0;
		var offsetX = 0;
		var offsetY = 0;
		var data = new (openfl_display__$internal_DrawCommandReader().default)(graphics.__commands);
		var x;
		var y;
		var width;
		var height;
		var kappa = 0.5522848;
		var ox;
		var oy;
		var xe;
		var ye;
		var xm;
		var ym;
		var _g = 0;
		var _g1 = graphics.__commands.types;
		while(_g < _g1.length) {
			var type = _g1[_g];
			++_g;
			switch(type._hx_index) {
			case 4:
				var c = data.readCubicCurveTo();
				CanvasGraphics.context.bezierCurveTo(c.float(0) - offsetX,c.float(1) - offsetY,c.float(2) - offsetX,c.float(3) - offsetY,c.float(4) - offsetX,c.float(5) - offsetY);
				positionX = c.float(4);
				positionY = c.float(5);
				break;
			case 5:
				var c1 = data.readCurveTo();
				CanvasGraphics.context.quadraticCurveTo(c1.float(0) - offsetX,c1.float(1) - offsetY,c1.float(2) - offsetX,c1.float(3) - offsetY);
				positionX = c1.float(2);
				positionY = c1.float(3);
				break;
			case 6:
				var c2 = data.readDrawCircle();
				CanvasGraphics.context.arc(c2.float(0) - offsetX,c2.float(1) - offsetY,c2.float(2),0,Math.PI * 2,true);
				break;
			case 7:
				var c3 = data.readDrawEllipse();
				x = c3.float(0);
				y = c3.float(1);
				width = c3.float(2);
				height = c3.float(3);
				x -= offsetX;
				y -= offsetY;
				ox = width / 2 * kappa;
				oy = height / 2 * kappa;
				xe = x + width;
				ye = y + height;
				xm = x + width / 2;
				ym = y + height / 2;
				CanvasGraphics.context.moveTo(x,ym);
				CanvasGraphics.context.bezierCurveTo(x,ym - oy,xm - ox,y,xm,y);
				CanvasGraphics.context.bezierCurveTo(xm + ox,y,xe,ym - oy,xe,ym);
				CanvasGraphics.context.bezierCurveTo(xe,ym + oy,xm + ox,ye,xm,ye);
				CanvasGraphics.context.bezierCurveTo(xm - ox,ye,x,ym + oy,x,ym);
				break;
			case 9:
				var c4 = data.readDrawRect();
				CanvasGraphics.context.beginPath();
				CanvasGraphics.context.rect(c4.float(0) - offsetX,c4.float(1) - offsetY,c4.float(2),c4.float(3));
				CanvasGraphics.context.closePath();
				break;
			case 10:
				var c5 = data.readDrawRoundRect();
				CanvasGraphics.drawRoundRect(c5.float(0) - offsetX,c5.float(1) - offsetY,c5.float(2),c5.float(3),c5.float(4),c5.obj(0));
				break;
			case 17:
				var c6 = data.readLineTo();
				CanvasGraphics.context.lineTo(c6.float(0) - offsetX,c6.float(1) - offsetY);
				positionX = c6.float(0);
				positionY = c6.float(1);
				break;
			case 18:
				var c7 = data.readMoveTo();
				CanvasGraphics.context.moveTo(c7.float(0) - offsetX,c7.float(1) - offsetY);
				positionX = c7.float(0);
				positionY = c7.float(1);
				break;
			default:
				data.skip(type);
			}
		}
		data.destroy();
	}
}
CanvasGraphics.setSmoothing = function(smooth) {
	if(!CanvasGraphics.allowSmoothing) {
		smooth = false;
	}
	if(CanvasGraphics.context.imageSmoothingEnabled != smooth) {
		CanvasGraphics.context.imageSmoothingEnabled = smooth;
	}
}
CanvasGraphics.__meta__ = { obj : { SuppressWarnings : ["checkstyle:FieldDocComment"]}, statics : { windingRule : { SuppressWarnings : ["checkstyle:Dynamic"]}, createBitmapFill : { SuppressWarnings : ["checkstyle:Dynamic"]}, createGradientPattern : { SuppressWarnings : ["checkstyle:Dynamic"]}}}
CanvasGraphics.SIN45 = 0.70710678118654752440084436210485
CanvasGraphics.TAN22 = 0.4142135623730950488016887242097
CanvasGraphics.fillCommands = new (openfl_display__$internal_DrawCommandBuffer().default)()
CanvasGraphics.strokeCommands = new (openfl_display__$internal_DrawCommandBuffer().default)()

// Export

exports.default = CanvasGraphics;